"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTRIBUTES_SET_VALUES_MAP = exports.ATTRIBUTES_SET_ATTRIBUTES = exports.ATTRIBUTES_SET_FORMAL_ATTRIBUTE_VALUES = exports.ATTRIBUTES_SET_FORMAL_ATTRIBUTES = void 0;
const const_1 = require("../../const");
exports.ATTRIBUTES_SET_FORMAL_ATTRIBUTES = `${const_1.PREFIX_ENRICH}ATTRIBUTES_SET_FORMAL_ATTRIBUTES`;
exports.ATTRIBUTES_SET_FORMAL_ATTRIBUTE_VALUES = `${const_1.PREFIX_ENRICH}ATTRIBUTES_SET_FORMAL_ATTRIBUTE_VALUES`;
exports.ATTRIBUTES_SET_ATTRIBUTES = `${const_1.PREFIX_ENRICH}ATTRIBUTES_SET_ATTRIBUTES`;
exports.ATTRIBUTES_SET_VALUES_MAP = `${const_1.PREFIX_ENRICH}ATTRIBUTES_SET_VALUES_MAP`;
